var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whatsapp-container"},[_c('TwilioHeader',{on:{"search-clicked":_vm.handleSearch,"menu-action":_vm.handleMenuAction}}),_c('TwilioFilters',{on:{"search":_vm.handleSearch,"filter-change":_vm.handleFilterChange}}),_c('TwilioChatPreview',{on:{"chat-selected":_vm.handleChatSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }